import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface IErrorPageProps {
    errorMsg: string;
}

const EmptyPage = ({errorMsg}: IErrorPageProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        border: '1px solid',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'transparent',
        minWidth: '130px'
      }}>
      <WarningAmberIcon color='error' sx={{height: '128px', width: '128px'}}/>
      <Typography component='div' variant='h2'
        sx={{ 
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '8px',
          m: 2}}>
        {errorMsg}
      </Typography>
    </Box>  
  );
};

export default EmptyPage;